import { getFunctions, httpsCallable } from "firebase/functions";

/**
 * Uploads a File to S3 via the Firebase Cloud Function.
 * Returns the S3 URL of the uploaded file.
 */
export async function uploadToS3(file: File): Promise<string> {
  const base64 = await fileToBase64(file);
  const functions = getFunctions();
  const uploadFn = httpsCallable<
    { fileBase64: string; fileName: string; contentType: string },
    { location: string }
  >(functions, "uploadToS3");

  const result = await uploadFn({
    fileBase64: base64,
    fileName: file.name,
    contentType: file.type,
  });

  return result.data.location;
}

function fileToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const dataUrl = reader.result as string;
      // Strip the data URL prefix (e.g. "data:audio/mpeg;base64,")
      const base64 = dataUrl.split(",")[1];
      resolve(base64);
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}
